





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Echarts from '@/components/Statement/echarts.vue';

@Component({
    components: { Echarts }
})

export default class DateRecordList extends Vue {
    @Prop() data!: {};
    @Prop() payMonthTotal!: []
    @Prop() earningMonthTotal!: []
    get dateOptions(){
        return {
            tooltip: {
                trigger: 'axis'
            },
            grid: {
                left: '10%',
                right: '1%',
                top: '3%',
                bottom: '5%',
                width:'85%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                splitLine: { show: false },
                data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
                axisLine:{
                    lineStyle:{
                        color: '#fff',
                    }
                }
            },
            yAxis: {
                type: 'value',
                splitLine: { show: false },
                axisLine:{
                    lineStyle:{
                        color: '#fff',
                    }
                }
            },
            series: [
                {
                    name: '收入',
                    type: 'line',
                    data: this.earningMonthTotal,
                    color: '#9fd26a',
                },
                {
                    name: '支出',
                    type: 'line',
                    data: this.payMonthTotal,
                    color:'#ea5e69'
                },
            ]
        }
    }
    isPay(detail: any) {
        return detail.selectedTag === '支出';
    }

    isEarning(detail: any) {
        return detail.selectedTag === '收入';
    }

}
